import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getGuidedBox = (state: State): any => state.guidedBoxes;

export const selectGuidedBox: MemoizedSelector<
  object,
  any
  > = createSelector(selectBpmnProcessState, getGuidedBox);


export const selectGuidedBoxDataById = (id: string) => { return createSelector(
  selectGuidedBox,
  (guideBoxMap) => {
    return guideBoxMap ? guideBoxMap[id] : null;
  }); };

export const selectGuidedBoxDataByIds = (ids: string[]) => { return createSelector(
  selectGuidedBox,
  (guideBoxMap) => {
    const filteredData = [];
    for (const key in guideBoxMap) {
      if (guideBoxMap.hasOwnProperty(key) && guideBoxMap[key] && guideBoxMap[key].guidingText && ids.indexOf(key) > -1) {
        filteredData[key] = guideBoxMap[key];
      }
    }
    return filteredData;
  }); };
